import { render, staticRenderFns } from "./Text.vue?vue&type=template&id=6819e822&scoped=true&"
import script from "./Text.vue?vue&type=script&lang=js&"
export * from "./Text.vue?vue&type=script&lang=js&"
import style0 from "./Text.vue?vue&type=style&index=0&id=6819e822&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6819e822",
  null
  
)

export default component.exports